"use client";
import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function ReviewCarousel({ features }) {
    return (
        <Swiper
            loop={features.length > 1}
            breakpoints={{
                600: { slidesPerView: 1, spaceBetween: 10 },
                640: { slidesPerView: 2, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 10 },
                1024: { slidesPerView: 3, spaceBetween: 10 },
            }}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            modules={[Autoplay]}
            className="mySwiper"
        >
            {features.map((feature, index) => (
                <SwiperSlide
                    key={`${index}-Slider`}
                    className="relative swiper-slide p-4 pt-10"
                >
                    <div className="bg-theme rounded-2xl border-b-2 border-blue-400 relative">
                        <div className="bg-themeLight h-72 p-4">
                            <div className="flex justify-center">
                                <Image
                                    src={feature.img}
                                    className="rounded-full absolute -top-10 border border-blue-300"
                                    alt={feature.name}
                                    width={100}
                                    height={100}
                                    style={{ maxWidth: "100%", height: "auto" }}
                                    loading="lazy" // Optimize off-screen images
                                />
                            </div>
                            <p className="mt-16 text-center text-white extrabold text-sm">
                                {feature.name}
                            </p>
                            <p className="mt-6 text-center text-white text-sm">
                                {feature.pera}
                            </p>
                            <Image
                                alt="quote"
                                className="h-8 absolute bottom-2 right-6"
                                src="/images/testimonial2.png"
                                width={32}
                                height={32}
                                loading="lazy"
                            />
                            <Image
                                alt="quote"
                                className="h-8 absolute top-2 left-6 rotate-180"
                                src="/images/testimonial2.png"
                                width={32}
                                height={32}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}